import { render, staticRenderFns } from "./NoRouteLogo.vue?vue&type=template&id=66978906&"
import script from "./NoRouteLogo.vue?vue&type=script&lang=ts&"
export * from "./NoRouteLogo.vue?vue&type=script&lang=ts&"
import style0 from "./NoRouteLogo.vue?vue&type=style&index=0&id=66978906&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports